import React from 'react';
import { Colors } from "_styles";

const UserCircleInitials = ({ initials, size = 40, backgroundColor = Colors.PRM_LIGHT_BLUE, textColor = "#fff", fontSize = 16 }) => {
    return (
        <div style={{
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: backgroundColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
        }}>
            <span style={{
                fontSize: fontSize,
                color: textColor,
                fontWeight: '500'
            }}>
                {initials}
            </span>
        </div>
    );
};

export default UserCircleInitials;